module.exports = __webpack_public_path__ + "img/4.d10ce08f.webp";